import { render, staticRenderFns } from "./AncillaryReissueInputsWrapper.vue?vue&type=template&id=264bd98a&scoped=true"
import script from "./AncillaryReissueInputsWrapper.vue?vue&type=script&lang=js"
export * from "./AncillaryReissueInputsWrapper.vue?vue&type=script&lang=js"
import style0 from "./AncillaryReissueInputsWrapper.vue?vue&type=style&index=0&id=264bd98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264bd98a",
  null
  
)

export default component.exports